import { fetchDataV2 } from "./utils";

export const getMarketingInvestmentReports = () => {
  return fetchDataV2("/power_bi_api/midas_fidelity");
};
